import { AnyAction, Dispatch, Middleware, MiddlewareAPI } from "redux";
import ActionTypes from "../../../../constants/ActionTypes";
import ApiUrls from "../../../../constants/ApiUrls";
import MiddlewareEntities from "../../../../constants/MiddlewareEntities";
import { apiRequest } from "../../api/actions";
import { setSendOrderToEmailStatus } from "./actions";


const saveOrderToEmailMiddleware: Middleware = (store: MiddlewareAPI) => (next: Dispatch) => (action: AnyAction) => {
  next(action);

  switch (action.type) {
  case ActionTypes.ORDER.MANHATTAN.SEND_ORDER_TO_EMAIL:
    next(apiRequest(
      null,
      'POST', ApiUrls.SEND_ORDER_TO_EMAIL,
      null,
      action.payload,
      MiddlewareEntities.ORDER.MANHATTAN.SEND_ORDER_TO_EMAIL,
      {}),
    );
    break;
  case `${MiddlewareEntities.ORDER.MANHATTAN.SEND_ORDER_TO_EMAIL} ${ActionTypes.API_SUCCESS}` :
    next(setSendOrderToEmailStatus(true));
    break;
  case `${MiddlewareEntities.ORDER.MANHATTAN.SEND_ORDER_TO_EMAIL} ${ActionTypes.API_ERROR}` :
    next(setSendOrderToEmailStatus(false));
    break;
  }
};

export default saveOrderToEmailMiddleware;
